/**
 * A frame pinned to the desktop is its own window (`desktop_pin_window.rs`),
 * stamped by its init script with the surface and the frame it shows
 * (plan 12 §4).
 */
import { isPinMaterial, type PinWindowStamp } from "./desktop-pin-contract";

declare global {
  interface Window {
    __DENKER_PIN__?: Partial<PinWindowStamp>;
  }
}

/** This webview is a frame pinned to the desktop. */
export const isPinSurface = () => window.__DENKER_SURFACE__ === "pin";

/**
 * The pinned frame when this webview is a pin window, else null. Without a
 * known material the widget paints its own solid card.
 */
export function pinSurfaceStamp(): PinWindowStamp | null {
  if (!isPinSurface()) return null;
  const stamp = window.__DENKER_PIN__;
  if (!stamp || typeof stamp.frameId !== "string" || !stamp.frameId) {
    return null;
  }
  return {
    frameId: stamp.frameId,
    projectId: typeof stamp.projectId === "string" ? stamp.projectId : "",
    material: isPinMaterial(stamp.material) ? stamp.material : "solid",
  };
}
